export class ScrollUtil {
    public static async scrollTo({
        elementParent,
        elementChild,
        offset,
        position
    }: {
        elementParent: HTMLElement;
        elementChild?: HTMLElement;
        offset?: number;
        position?: "start" | "end" | "center";
    }): Promise<boolean> {
        if (!elementParent) {
            console.warn("Element parent is not defined or returned null.");
            return false;
        }
        if (!offset && elementChild) {
            const elementRect = elementChild.getBoundingClientRect();
            const containerRect = elementParent.getBoundingClientRect();
            if (position) {
                const positions: Record<string, number> = {
                    start:
                        elementRect.top -
                        containerRect.top +
                        elementParent.scrollTop
                };
                offset = positions[position] || 0;
            } else {
                offset =
                    elementRect.top -
                    containerRect.top +
                    elementParent.scrollTop -
                    elementParent.clientHeight / 2 +
                    elementRect.height / 2;
            }
        }
        return new Promise<boolean>((resolve) => {
            let isScrolling: any = null;
            let isLoading: boolean = false;
            elementParent.scrollTo({ top: offset, behavior: "smooth" });
            const onScroll = () => {
                clearTimeout(isScrolling);
                isLoading = true;
                isScrolling = setTimeout(() => {
                    elementParent.removeEventListener("scroll", onScroll);
                    resolve(true);
                }, 100);
            };
            elementParent.addEventListener("scroll", onScroll);
            setTimeout(() => {
                if (isLoading === false) resolve(false);
            }, 90);
        });
    }
}
